import React, { memo, useState, forwardRef } from 'react';
import MSelect from '../../../components/controls/MSelect';
import { leaveTypes } from '../common';

interface IData {
    [key: string]: any;
}

const LeaveOPtions = memo(forwardRef<any, IData>((props, _ref) => {
    const [expand, _setExpand] = useState(true);

    let selectedIndex = null;
    const selectTimeoffType = async (value) => {
        let _index = value === '' ? 1 : value;
        selectedIndex = _index;

        // eslint-disable-next-line eqeqeq -- intentionally match both null and undefined
        if (_index != null) {
            let applyDay = `Day_${props.column.colId.split('-')[2]}`;
            let originValue = props.data[applyDay];

            props.data[applyDay] = _index;
            if (!props.data['ChangedList'].find((x: any) => x.applyDay === applyDay)) {
                props.data['ChangedList'].push({ applyDay, originValue });
            } else {
                let originValue = props.data['ChangedList'].find((x: any) => x.applyDay === applyDay)?.originValue;
                if (originValue === _index) {
                    props.data['ChangedList'] = props.data['ChangedList'].filter((x: any) => x.applyDay !== applyDay);
                }
            }
        }
    };
  
    return (
        <div>
            <MSelect
                choices={leaveTypes}
                onChange={selectTimeoffType}
                open={expand}
                value={props.data[`Day_${props.column.colId.split('-')[2]}`]}
                onClose={() => {
                    // eslint-disable-next-line eqeqeq -- intentionally loose: matches null/undefined and tolerates numeric/string value mismatch
                    if (selectedIndex == null || selectedIndex == props.data[`Day_${props.column.colId.split('-')[2]}`]) {
                        props.api.stopEditing();
                    }
                }}
            ></MSelect>
        </div>
    );
})
);
export default LeaveOPtions;